package org.example.zone360.components

import org.example.zone360.utils.Environment
import org.example.zone360.utils.currentEnv

fun debugPrintln(message: Any?) {
    if (currentEnv != Environment.PRODUCTION) {
        println(message)
    }
}